export default __webpack_public_path__ + "static/media/TIF.ae87bd04.svg";